<template>
  <div class="h-full flex items-center pt-2">
    <SelectInput
      :key="params.id"
      v-model="currentValue"
      :options="options"
      clearable
      append-to-body
      compact
      :placeholder="$t('common.select')"
      :style="params.style"
    />
  </div>
</template>

<script>
import { SelectInput } from '@/components/Inputs';

export default {
  components: { SelectInput },
  data: function () {
    return {
      currentValue: null,
    };
  },
  computed: {
    options() {
      return this.params.options.map((option) => ({
        ...option,
        label: this.params.getLabel
          ? this.params.getLabel(option.value)
          : option.label,
      }));
    },
  },
  beforeMount() {
    const currentFilter =
      this.params.api?.getFilterModel()[this.params.column.colId];
    if (currentFilter && currentFilter.filter !== undefined) {
      const matchedOption = this.options.find(
        (opt) => opt.value === currentFilter.filter,
      );
      this.currentValue = matchedOption || null;
    }
  },
  methods: {
    onInputBoxChanged() {
      if (this.params.api) {
        this.params.api.setFilterModel({
          ...this.params.api.getFilterModel(),
          [this.params.column.colId]:
            this.currentValue?.value !== undefined
              ? {
                  filterType: 'select',
                  type: 'equals',
                  filter: this.currentValue.value,
                }
              : null,
        });
      }
    },

    onFloatingFilterChanged(change) {
      const matchedOption = this.options.find((opt) => opt.value === change);
      this.currentValue = matchedOption || null;
    },
  },
  watch: {
    currentValue() {
      this.onInputBoxChanged();
    },
    options(newOptions) {
      if (this.currentValue) {
        const stillExists = newOptions.find(
          (option) => option.value === this.currentValue.value,
        );
        if (!stillExists) {
          this.currentValue = null;
        }
      }
    },
  },
};
</script>
